module.exports = __webpack_public_path__ + "img/logo520x.5242a233.png";